import React, { useState, useRef, useEffect } from "react";
import { Typography, Box, Grid, ButtonGroup, Button } from "@mui/material";

import { DISABLE_SWIPE } from "../utilities/enums";
import { useOverflowObserver, getLocalData, dbKeyOFPFiles } from "../helpers";

export const OFP = ({ flightId }) => {
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [isSwipeDisabled, setIsSwipeDisabled] = useState(true);
  const [files, setFiles] = useState([]);
  const [selectedOFP, setSelecedOFP] = useState(files[0]);

  useOverflowObserver(containerRef, contentRef, setIsSwipeDisabled);

  useEffect(() => {
    async function fetchData() {
      const parsedOFPArray =
        (await getLocalData(dbKeyOFPFiles(flightId))) || [];

      setFiles((prevState) => [...prevState, ...parsedOFPArray]);
      setSelecedOFP(parsedOFPArray[0]);
    }
    fetchData();
  }, [flightId]);

  return (
    <>
      <Box className={"content-container"} style={{ paddingBottom: 0 }}>
        <Typography variant="h6" gutterBottom textAlign={"center"}>
          OFP
        </Typography>
        {files.length > 1 && (
          <Grid item style={{ alignSelf: "center" }}>
            <ButtonGroup variant="text">
              {files.map((item, index) => {
                return (
                  <Button
                    key={index}
                    onClick={() => setSelecedOFP(item)}
                    className="ofp-button"
                  >
                    {index + 1}
                  </Button>
                );
              })}
            </ButtonGroup>
          </Grid>
        )}
      </Box>
      <div
        ref={containerRef}
        className={`crew-msg-container ${isSwipeDisabled ? DISABLE_SWIPE : ""}`}
      >
        <div ref={contentRef} style={{ width: "fit-content" }}>
          <Grid container>
            <Grid item>
              {selectedOFP ? (
                <pre>{selectedOFP?.value}</pre>
              ) : (
                <Typography variant="body1" gutterBottom>
                  There are no files.
                </Typography>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
    </>
  );
};
